<template>
  <div class="messages" :class="[showMessages ? 'messages-active': 'messages-inactive']">
    <div class="message success" :class="{show:showSuccess}">
      <i class="fa fa-times" @click="closeMessage('success')"></i>
      <i class="fa fa-check-circle indicator"></i>
      <div class="message-inner">
        <span v-if="messages.success.length == 1" v-html="messages.success[0].message"></span>
        <ul v-if="messages.success.length > 1">
          <li v-for="message in messages.success" v-html="message.message"></li>
        </ul>
      </div>
    </div>
    <div class="message error" :class="{show:showError}">
      <i class="fa fa-times" @click="closeMessage('error')"></i>
      <i class="fa fa-exclamation-circle indicator"></i>
      <div class="message-inner">
        <span v-if="messages.error.length == 1" v-html="messages.error[0].message"></span>
        <ul v-if="messages.error.length > 1">
          <li v-for="message in messages.error" v-html="message.message"></li>
        </ul>
      </div>
    </div>
    <div class="message info" :class="{show:showInfo}">
      <i class="fa fa-times" @click="closeMessage('info')"></i>
      <i class="fa fa-info-circle indicator"></i>
      <div class="message-inner">
        <span v-if="messages.info.length == 1" v-html="messages.info[0].message"></span>
        <ul v-if="messages.info.length > 1">
          <li v-for="message in messages.info" v-html="message.message"></li>
        </ul>
      </div>
    </div>
    <div class="message warning" :class="{show:showWarning}">
      <i class="fa fa-times" @click="closeMessage('warning')"></i>
      <i class="fa fa-info-circle indicator"></i>
      <div class="message-inner">
        <span v-if="messages.warning.length == 1" v-html="messages.warning[0].message"></span>
        <ul v-if="messages.warning.length > 1">
          <li v-for="message in messages.warning" v-html="message.message"></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'messages',
  components: {},
  props: [],
  data: () => ({
    messages: {
      success: [],
      error: [],
      info: [],
      warning: []
    }
  }),
  computed: {
    showMessages: function () {
      return this.messages.success.length > 0 || this.messages.error.length > 0 || this.messages.info.length > 0;
    },
    showSuccess: function () {
      return this.messages.success.length > 0;
    },
    showError: function () {
      return this.messages.error.length > 0;
    },
    showInfo: function () {
      return this.messages.info.length > 0;
    },
    showWarning: function () {
      return this.messages.warning.length > 0;
    }
  },
  methods: {
    sendMessage: function (type, message) {

      if (Object.prototype.toString.call(message) !== Object.prototype.toString.call([]))
        message = [message];

      for (var i = 0; i < message.length; i++) {
        var messageIndex = this.checkMessageExists(type, message[i]);
        if (messageIndex === false) {
          this.messages[type].push({message: message[i], count: window.V._router.routeCount});
        }
      }

    },
    checkMessageExists: function (type, message) {
      for (var i = 0; i < this.messages[type].length; i++) {
        if (this.messages[type][i].message == message) {
          return i;
        }
      }
      return false;
    },
    closeMessage: function (type) {
      this.messages[type] = [];
    },
    clearMessages: function () {
      this.closeMessage('success');
      this.closeMessage('error');
      this.closeMessage('info');
      this.closeMessage('warning');
    },
    checkCountsForAutoDisappear: function () {
      this.checkMessageCount('success');
      this.checkMessageCount('error');
      this.checkMessageCount('info');
      this.checkMessageCount('warning');
    },
    checkMessageCount: function (type) {

      var count = window.V._router.routeCount;

      for (var i = 0; i < this.messages[type].length; i++) {
        if (this.messages[type][i].count == count - 3) {
          this.messages[type].splice(i, 1);
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
